import {ReferenceFormatModel} from '../../../models/api/autolinkerModel';
import {StringOrTemplate} from '../commons/stringTemplateModel';
import {ExpressionAction} from '../expressions/expressionActions';
import {AutolinkerEditorState} from './autolinkerEditorState';

/*
 * Type enum.
 */

export enum AutolinkerEditorActionTypesEnum {
  UPDATE_DESCRIPTION = '@@autolinker/UPDATE_DESCRIPTION',
  UPDATE_REFERENCE_FORMAT = '@@autolinker/UPDATE_REFERENCE_FORMAT',
  UPDATE_URL_BUILDER = '@@autolinker/UPDATE_URL_BUILDER',
}

/*
 * Types.
 */

interface UpdateAutolinkerDescription {
  type: AutolinkerEditorActionTypesEnum.UPDATE_DESCRIPTION;
  description: string;
}

interface UpdateAutolinkerReferenceFormat {
  type: AutolinkerEditorActionTypesEnum.UPDATE_REFERENCE_FORMAT;
  referenceFormat: ReferenceFormatModel;
}

interface UpdateAutolinkerUrlBuilder {
  type: AutolinkerEditorActionTypesEnum.UPDATE_URL_BUILDER;
  urlBuilder: StringOrTemplate;
}

/*
 * Combined action type.
 */

export type AutolinkerEditorAction =
  | UpdateAutolinkerDescription
  | UpdateAutolinkerReferenceFormat
  | UpdateAutolinkerUrlBuilder
  | ExpressionAction<AutolinkerEditorState>;
